export const SMALL_DEVICE_MAX_WIDTH = 768;
export const LARGE_DEVICE_MAX_WIDTH = 1080;
export const TINY_DEVICE_MAX_WIDTH = 280;
